<template>
  <div v-if="isLoaded">
    <DeleteModal
      :is-delete-modal-active.sync="isDeleteModalActive"
      :items="deleteItem"
      @confirm-delete="confirmDelete($event)" />
    <ContactRelationAdd
      ref="contactRelationAdd"
      :is-sidebar-active.sync="isSidebarActive"
      @add-contact-relation="addContactRelation($event)" />
    <ContactRelationDetail
      :is-sidebar-active.sync="isSidebarDetailActive"
      :initial-contact-relation="initialContactRelation"
      :selected-item.sync="selectedItem"
      @delete-item="openDeleteModal($event)"
      @edit-contact-relation="editContactRelation($event)" />
    <ContactRelationFillter
      :search.sync="filter.searchName"
      :status-filter.sync="filter.status"
      @fetch-filter="fetchFilter()" />
    <b-card class="mt-2">
      <TableTop
        v-model="pagination.limit"
        label="Add Contact Relation"
        @active-sidebar="activeSidebar()"
        @change="fetchFilter()" />
      <b-table
        :items="items"
        :fields="fields"
        striped
        hover
        responsive
        @sort-changed="sortFilter($event)"
        @row-clicked="rowClick($event)">
        <template #cell(status)="data">
          <b-badge :variant="$statusValue(data.value)">
            {{ data.value | formatStatusData }}
          </b-badge>
        </template>
        <template #cell(name)="data">
          <span class="font-weight-semibold">{{ data.value }}</span>
        </template>
        <template #cell(remark)="data">
          <div v-if="data && data.item && data.item.remark">
            {{ data.item.remark }}
          </div>
          <div v-else>
            -
          </div>
        </template>
      </b-table>
      <b-row>
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center justify-content-sm-end">
          <b-pagination
            v-model="pagination.page"
            :total-rows="pagination.totalDocs"
            :per-page="pagination.limit"
            first-number
            last-number
            class="mb-1 mt-2 mr-1"
            prev-class="prev-item"
            next-class="next-item"
            @change="showCurrentPage($event)">
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18" />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ContactRelationAdd from '@/components/New/ContactRelation/ContactRelationAdd.vue'
import ContactRelationFillter from '@/components/New/ContactRelation/ContactRelationFillter.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ContactRelationDetail from '@/components/New/ContactRelation/ContactRelationDetail.vue'
import DeleteModal from '@/components/DeleteModal.vue'
import TableTop from '@/components/TableTop.vue'
import ContactRelationProvider from '@/resources/ContactRelationProvider'

const ContactRelationService = new ContactRelationProvider()

export default {
  components: {
    ContactRelationAdd,
    ContactRelationFillter,
    ContactRelationDetail,
    DeleteModal,
    TableTop
  },
  data () {
    return {
      isLoaded: false,
      isSidebarActive: false,
      isSidebarDetailActive: false,
      isDeleteModalActive: false,
      filter: {
        searchName: '',
        status: ''
      },
      pagination: {
        page: 1,
        limit: 10,
        totalDocs: 0
      },
      fields: [
        { key: 'name', label: 'Name', sortable: true },
        { key: 'remark', label: 'Remark' },
        { key: 'status', label: 'Status' }
      ],
      items: [],
      initialContactRelation: {},
      selectedItem: {},
      deleteItem: {}
    }
  },
  async created () {
    try {
      await this.getContactRelation()
    } finally {
      this.isLoaded = true
    }
  },
  methods: {
    fetchFilter () {
      this.setPagination(1)
      this.getContactRelation()
    },
    openDeleteModal (val) {
      this.deleteItem = { ...val }
      this.isDeleteModalActive = true
    },
    async editContactRelation (val) {
      try {
        const payload = { ...val }
        delete payload.id
        const { data } = await ContactRelationService.update(val.id, payload)
        await this.getContactRelation()
        this.setInitialContactRelationAndSelectItem(data)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Updated Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Contact Relation has been updated'
          }
        })
      } catch (err) {
        console.error(err)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Contact Relation has been Failed'
          }
        })
      }
    },
    rowClick (val) {
      this.setInitialContactRelationAndSelectItem(val)
      this.isSidebarDetailActive = true
    },
    setInitialContactRelationAndSelectItem (val) {
      this.selectedItem = { ...val }
      this.initialContactRelation = { ...val }
    },
    async confirmDelete (val) {
      try {
        this.isSidebarDetailActive = false
        await ContactRelationService.softDelete(val.ID)
        await this.getContactRelation()
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Contact Relation has been deleted'
          }
        })
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Deleted Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: `😞 Contact Relation has been Failed ${error}`
          }
        })
      }
    },
    activeSidebar () {
      this.isSidebarActive = true
    },
    async getContactRelation () {
      try {
        const page = this.$route?.query?.page || this.pagination?.page || 1
        const limit = this.$route?.query?.limit || this.pagination?.limit || 10
        const data = await ContactRelationService.paginate(
          page, limit,
          this.filter
        )
        this.setPagination(data.page, data.totalDocs)
        this.items = [...data.data]
      } catch (err) {
        console.error(err)
      }
    },
    async addContactRelation (val) {
      try {
        await ContactRelationService.create(val)
        await this.getContactRelation()
        this.resetFormAndToggleSideBar(this.$refs.contactRelationAdd)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Record Successfully',
            icon: 'EditIcon',
            variant: 'success',
            text: '👋 Contact Relation has been added'
          }
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Add Fail',
            icon: 'EditIcon',
            variant: 'danger',
            text: '😞 Contact Relation has been Failed'
          }
        })
      }
    },
    sortFilter (ctx) {
      console.log(ctx)
    },
    showCurrentPage (page) {
      this.setPagination(page)
      this.getContactRelation()
    },
    setPagination (page, totalDocs) {
      this.$router.replace(`contact-relation?page=${page}`)
      this.pagination.page = page || this.pagination.page
      this.pagination.totalDocs = totalDocs || this.pagination.totalDocs
    },
    resetFormAndToggleSideBar (ref) {
      this.isSidebarActive = !this.isSidebarActive
      if (ref && ref.resetForm()) ref.resetForm()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-body {
  padding: 0;
}
</style>
